"use client";

import type { ProcessedCourse } from "@/common/course/types";
import { useSingleCourseTrafficConfig } from "@/monarch/rules/singleCourseTraffic/useSingleCourseTraffic";
import { buildDetailPricingFromCourse } from "./buildDetailPricingFromCourse";
import {
  useDetailPricingData,
  type DetailPricingData,
} from "./useDetailPricingData";

export type UseCourseDetailPricingDataParams = {
  course: ProcessedCourse;
};

export function useCourseDetailPricingData({
  course,
}: UseCourseDetailPricingDataParams): DetailPricingData | null {
  const { geoPricing } = useSingleCourseTrafficConfig({ course });

  return useDetailPricingData({
    pricingData: buildDetailPricingFromCourse(course),
    geoPricing,
    product: {
      productType: course.productType,
      partners: course.partners?.map((partner) => ({ key: partner.key })),
    },
  });
}
